import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-slider-textbox",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./slider-textbox.component.html",
    styleUrls: ["./slider-textbox.component.css"],
    standalone: false
})
export class SliderTextboxComponent implements OnInit {
    @Input() public intervalCount: number = 1000;
    @Input() public sliderMin = 0;
    @Input() public sliderMax = 1;
    @Input() public precision = 2;
    @Input() public min = 0;
    @Input() public max = 1;
    @Input() public integer = false;
    @Input() public disabled = false;

    public sliderValue = 0;
    public numDps = 0;

    @Output() public change = new EventEmitter<number>();

    public get valueString() { return this._value != null ? this._value.toFixed(this.numDps) : ""; }

    private _value = 0;
    @Input()
    public get value() { return this._value; }
    public set value(value: number) {
        this._value = value;
        this.sliderValue = this.intervalCount * (this.value - this.min) / (this.max - this.min);
    }

    public ngOnInit() {
        if (!this.integer) {
            this.numDps = this.precision;
        } else {
            this.numDps = 0;
            this.intervalCount = this.max - this.min;
        }
    }

    public updateValue(valueStr: string) {
        this.value = parseFloat(valueStr);
        this.change.next(this.value);
    }

    public updateSliderValue(sliderValueStr: string) {
        const sliderValue = parseInt(sliderValueStr);
        this.sliderValue = sliderValue;
        this._value = this.min + (this.integer ? this.sliderValue : ((this.max - this.min) * (sliderValue / this.intervalCount)));
        this.change.next(this.value);
    }
}
